import { ethers as i } from "ethers";
import { DistributionsContractAbi as o } from "@deorderbook/contracts/abi";
import { DistributionsAddress as n } from "@deorderbook/contracts";
import { signer as s, provider as e } from "./provider.mjs";
const c = () => new i.Contract(
  n,
  o
), f = (r = !1) => {
  const t = c();
  return r ? t.connect(s) : t.connect(e);
};
export {
  c as initDistributionsContract,
  f as useDistributionsContract
};
//# sourceMappingURL=distributionsContract.mjs.map
